import { useIntl } from 'react-intl';
import type { Chip } from '@alltrails/denali/components/SelectionChips';
import type TrailActivityType from '@alltrails/trails/types/TrailActivityType';
import getTrailActivityTypeLabel from '@alltrails/trails/utils/getTrailActivityTypeLabel';
import type { ChipsFilterConfigV2 } from '../../components/FilterControlV2/types';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import getActivityIcon from '../../utils/getActivityIcon';

export const activityTypes: TrailActivityType[] = [
  'hiking',
  'walking',
  'trail-running',
  'running',
  'mountain-biking',
  'road-biking',
  'off-road-driving',
  'scenic-driving',
  'backpacking',
  'camping',
  'bike-touring',
  'snowshoeing',
  'cross-country-skiing',
  'skiing',
  'paddle-sports',
  'fishing',
  'horseback-riding',
  'birding',
  'rock-climbing',
  'via-ferrata'
];

const collapsedChipCount = 8;

const useActivityChipsConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void
): ChipsFilterConfigV2 => {
  const intl = useIntl();

  const selectedId = exploreServiceFilters.activity?.length ? exploreServiceFilters.activity[0] : undefined;

  const chips: Chip[] = activityTypes.map(activity => {
    const Component = getActivityIcon(activity);
    return { id: activity, label: getTrailActivityTypeLabel(intl, activity), ...(Component ? { icon: { Component } } : {}) };
  });

  const onChange = (chip: Chip) => {
    const newFilters = { ...exploreServiceFilters };
    if (selectedId === chip.id) {
      delete newFilters.activity;
    } else {
      newFilters.activity = [chip.id as TrailActivityType];
    }
    onFiltersChange(newFilters);
  };

  return {
    type: 'chips',
    id: 'activity',
    collapsedChipCount,
    selectionChips: {
      title: intl.formatMessage({ defaultMessage: 'Activity' }),
      isMultiSelect: false,
      allowDeselect: true,
      chips,
      selectedChips: chips.filter(chip => chip.id === selectedId),
      onChange
    }
  };
};

export default useActivityChipsConfig;
